<template>
  <div class="conteudo-categoria">
    <div class="isLoading" v-if="carregando.noticia">
      <categoria-loading />
      <mobile-loading />
    </div>
    <ul class="materias" v-if="!carregando.noticia">
      <transition-group name="slide" mode="out-in" tag="li">
        <template v-if="getData.length > 0">
          <li v-for="materia in getData" :key="materia.id + '-' + materia.hora_publicacao">
            <router-link
              :to="{ path: `/categoria/${materia.categoria.slug}/post/${materia.slug}` }"
            >
              <a>
                <article class="materia">
                  <div class="capa-materia">
                    <span class="categoria">{{ materia.categoria.descricao }}</span>
                    <img
                      v-if="materia.sm"
                      :src="materia.sm"
                      :alt="materia.titulo"
                      class="imagem-destaque"
                    />
                    <img
                      v-else
                      src="@/assets/imgs/no-image-portal.jpg"
                      :alt="materia.titulo"
                      class="imagem-destaque"
                    />
                  </div>
                  <div class="texto-materia">
                    <span>
                      <strong>Postado em:</strong>
                      {{ materia.data_publicacao }} - {{ materia.hora_publicacao }}
                    </span>
                    <h2>{{ materia.titulo }}</h2>
                    <p>{{ materia.resumo }}</p>
                  </div>
                </article>
              </a>
            </router-link>
          </li>
        </template>
      </transition-group>

      <BotaoCarregar
        :loading="carregando.more"
        :disabled="carregando.more"
        @click.native="lazyNoticia"
        :ativo="showButton"
      />
    </ul>
    <error-404
      v-if="getData.length <= 0 && !carregando.noticia"
    >Não há nenhuma matéria cadastrada nesta Seção.</error-404>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BotaoCarregar from '../../BotaoCarregar.vue';
import CategoriaLoading from '../../Loading/CategoriaLoading';
import MobileLoading from '../../Loading/MobileLoading';
import Error404 from '../error/404';
import mixins from '@/helpers/mixins';

export default {
  name: 'categoria',
  mixins: [mixins],
  data() {
    return {
      cat: null,
    };
  },
  components: {
    BotaoCarregar,
    CategoriaLoading,
    MobileLoading,
    Error404,
  },
  computed: {
    ...mapGetters({
      carregando: 'baseTag/carregando',
      showButton: 'baseTag/showButton',
      getData: 'baseTag/getData',
      uf: 'user/uf',
    }),
  },

  methods: {
    ...mapActions({
      getNoticias: 'baseTag/getNoticias',
      getMoreNoticias: 'baseTag/getMoreNoticias',
    }),
    lazyNoticia() {
      const { categoria } = this.$route.params;
      this.getMoreNoticias(categoria);
    },
  },
  beforeCreate() {
    const { categoria } = this.$route.params;
    this.$store
      .dispatch('categoria/findCategoria', categoria)
      .then(response => {
        this.$store.dispatch('apiRoute/setTitle', {
          title: response.categoria,
        });
      });
  },
  mounted() {
    const { tag } = this.$route.params;
    this.$nextTick(() => {
      this.getNoticias(tag);
    });
  },
  watch: {
    $route(after) {
      const { tag } = after.params;
      // this.$store
      //   .dispatch('categoria/findCategoria', categoria)
      //   .then(response => {
      //     this.$store.dispatch('apiRoute/setTitle', {
      //       title: response.categoria,
      //     });
      //   });
      this.getNoticias(tag);
    },
    uf() {
      this.getNoticias(this.cat);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

$largura-foto-grande: 290px;
$altura-foto-grande: 185px;

.noticia-not-found {
  width: 600px;
  height: 300px;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  & .nnf-img-text {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  & p {
    text-align: center;
    font-family: VivoTypeBold, sans-serif;
    font-size: 2rem;
    color: $cor_cinza;
  }
}

.conteudo-categoria {
  @extend %flex;
  @extend %direction-row;
  @extend %justify-between;
  @extend %area-de-utilizacao;
  margin: 0 auto;
  position: relative;

  & .isLoading {
    position: absolute;
    top: 0;
    left: 0;
    width: 600px;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
  }

  & .materias {
    @extend %flex;
    @extend %direction-row;
    @extend %justify-between;
    @extend %flex-wrap;
    width: 600px;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;

    & li {
      & a {
        margin: 0px;
        padding: 0px;
        text-decoration: none;
        cursor: pointer;

        & article {
          @extend %flex;
          @extend %direction-row;
          @extend %justify-between;
          @extend %align-items-center;
          width: 600px;
          margin-bottom: 30px;

          & .capa-materia {
            min-width: $largura-foto-grande;
            max-width: $largura-foto-grande;
            height: $altura-foto-grande;
            border-radius: 5px;
            position: relative;

            &:hover {
              transition: 0.3s ease;
              @extend %gradiente_twilight;
            }

            &:hover {
              transform: scale(1.03);

              & > .categoria {
                background: transparent;
                font-size: 13px;
                // color: transparent;
                // border: 1px solid white;
              }
            }

            & .categoria {
              position: absolute;
              font-size: 10px;
              top: 3px;
              left: 3px;
              color: white;
              padding: 0px 3px;
              border-radius: 3px;
              font-weight: 600;
              // @extend %gradiente_rosa;
              background: $cor_rosa;
              opacity: 1 !important;
              z-index: 99;
              transition: all 0.2s ease-in-out;
            }

            & img:hover {
              transition: 0.3s ease;
              opacity: 0.3;
            }

            & .imagem-destaque {
              transition: 0.5s ease;
              object-fit: cover;
              width: 100%;
              height: $altura-foto-grande;
              border-radius: 5px;
            }
          }

          & .texto-materia {
            min-width: $largura-foto-grande;
            max-width: $largura-foto-grande;

            & h2 {
              font-family: 'VivoType';
              font-weight: bolder;
              color: $cor_roxo;
              font-size: 24px;
              line-height: 28px;
              // letter-spacing: 0.01vmax;
              margin: 5px 0px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }

            & p {
              font-size: 13px;
              margin: 0px;
              font-family: 'OpenSans';
              color: $cor_cinza_dark;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
            }

            & span {
              font-style: italic;
              font-size: 10px;
              font-weight: 500;
              color: $cor_cinza;
            }
          }
        }
      }
    }
  }
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .conteudo-categoria {
    // flex-direction: column !important;
    // justify-content: flex-start !important;
    // align-items: center !important;
    // max-width: 80vw;
    // margin: 0 auto;
    // margin-top: calc((((100vw + 100vh) * 2) / 40) + 0px);

    & .isLoading {
      position: relative;
      width: 80vw;
      min-height: 40vh;
    }

    & .materias {
      flex-direction: column;
      justify-content: flex-start;
      max-width: 100vw;

      & li {
        margin: 0 auto;

        & a {
          & article {
            flex-direction: column !important;
            justify-content: flex-start !important;
            width: 80vw !important;
            margin-bottom: calc((((100vw + 100vh) * 2) / 80) + 10px) !important;

            & .capa-materia {
              min-width: 80vw !important;
              max-width: 80vw !important;
              height: 5.5% !important;

              &:hover {
                transform: scale(1.02) !important;

                & > .categoria {
                  font-size: calc(
                    (((100vw + 100vh) * 2) / 250) + 8px
                  ) !important;
                }
              }

              & .categoria {
                font-size: calc((((100vw + 100vh) * 2) / 300) + 4px) !important;
              }

              & .imagem-destaque {
                height: 5.5% !important;
              }
            }

            & .texto-materia {
              margin: 0px !important;
              min-width: 100% !important;
              max-width: 100% !important;

              & h2 {
                font-size: calc((((100vw + 100vh) * 2) / 170) + 6px) !important;
                line-height: calc(
                  (((100vw + 100vh) * 2) / 170) + 8px
                ) !important;
                margin: 3% 0 2% !important;
              }

              & p {
                font-size: calc((((100vw + 100vh) * 2) / 240) + 3px) !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
